import React from "react";
import { Modal } from "antd";
import moment from "moment";
import { IPendingWalletCreationRequest } from "../hooks/usePendingWalletCreationRequests";

interface IViewWalletDetailsModalProps {
  visible: boolean;
  onClose: () => void;
  walletData: IPendingWalletCreationRequest | null;
}

const ViewWalletDetailsModal: React.FC<IViewWalletDetailsModalProps> = ({
  visible,
  onClose,
  walletData,
}) => {
  if (!walletData) return null;

  return (
    <Modal
      title="Wallet Creation Request Details"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <div style={{ padding: "1rem 0" }}>
        <div className="row mb-3">
          <div className="col-md-6">
            <strong>Maker Checker Reference:</strong>
            <div>{walletData.makerCheckerReference}</div>
          </div>
          <div className="col-md-6">
            <strong>Target ID:</strong>
            <div>{walletData.targetId}</div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <strong>Consumer Type:</strong>
            <div>{walletData.consumerType}</div>
          </div>
          <div className="col-md-6">
            <strong>Client Type:</strong>
            <div>{walletData.clientType}</div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <strong>Currency:</strong>
            <div>{walletData.currency}</div>
          </div>
          <div className="col-md-6">
            <strong>Provider Type:</strong>
            <div>{walletData.providerType}</div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <strong>Effective Date:</strong>
            <div>
              {walletData.effectiveDate
                ? moment(walletData.effectiveDate).format("DD-MM-YYYY HH:mm:ss")
                : "N/A"}
            </div>
          </div>
          <div className="col-md-6">
            <strong>Channel ID:</strong>
            <div>{walletData.channelId || "N/A"}</div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <strong>Digital Bank:</strong>
            <div>
              <span
                className={`badge ${
                  walletData.isDigitalBank ? "badge-success" : "badge-secondary"
                }`}
              >
                {walletData.isDigitalBank ? "Yes" : "No"}
              </span>
            </div>
          </div>
          <div className="col-md-4">
            <strong>External Wallet:</strong>
            <div>
              <span
                className={`badge ${
                  walletData.isExternalWallet
                    ? "badge-warning"
                    : "badge-secondary"
                }`}
              >
                {walletData.isExternalWallet ? "Yes" : "No"}
              </span>
            </div>
          </div>
          <div className="col-md-4">
            <strong>Created By Admin:</strong>
            <div>
              <span
                className={`badge ${
                  walletData.createdByAdmin ? "badge-info" : "badge-secondary"
                }`}
              >
                {walletData.createdByAdmin ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <strong>Post No Debit:</strong>
            <div>
              <span
                className={`badge ${
                  walletData.postNoDebit ? "badge-warning" : "badge-secondary"
                }`}
              >
                {walletData.postNoDebit ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <strong>Note:</strong>
            <div
              style={{
                padding: "0.75rem",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px",
                marginTop: "0.5rem",
              }}
            >
              {walletData.note || "No note provided"}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewWalletDetailsModal;
